const ITEMS = [
  "Intelligent Investing",
  "Enduring Results",
  "Research-Driven",
  "AMFI Registered · ARN-365843",
  "Goal-Based Investing",
  "Disciplined Wealth Creation",
];

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-[#D4AF37]/15 bg-[#050505] py-7"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="flex whitespace-nowrap animate-marquee-slow will-change-transform">
        {[...ITEMS, ...ITEMS].map((t, i) => (
          <span
            key={i}
            className="font-display text-2xl md:text-4xl font-semibold uppercase tracking-[0.18em] flex items-center"
          >
            <span className="text-outline-gold">{t}</span>
            <span className="text-[#D4AF37] mx-8 text-xl md:text-3xl">·</span>
          </span>
        ))}
      </div>
    </div>
  );
}
